export function setHeadMeta(title: string, description: string) {
    document.title = title;

    let metaDesc = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = 'description';
        document.head.appendChild(metaDesc);
    }
    metaDesc.content = description;

    // Add favicon links
    const favicons = [
        { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png' },
        { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32x32.png' },
        { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon-16x16.png' }
    ];

    favicons.forEach(faviconInfo => {
        let link = document.querySelector<HTMLLinkElement>(`link[rel='${faviconInfo.rel}'][sizes='${faviconInfo.sizes}']`);
        if (!link) {
            link = document.createElement('link');
            link.rel = faviconInfo.rel;
            if (faviconInfo.type) {
                (link as any).type = faviconInfo.type;
            }
            if (faviconInfo.sizes) {
                (link as any).sizes = faviconInfo.sizes;
            }
            document.head.appendChild(link);
        }
        link.href = faviconInfo.href;
    });
}
